import {useAuthContext} from "./useAuthContext"

// We need to come back in here later and import the invoice and quotes context and REMOVE the context once the user LOGS OUT


export const useLogout = () => {
    const {dispatch} = useAuthContext()

    const logout = () => {
        //remove user from local storage
        localStorage.removeItem('user')

        //dispatch logout to Authcontext
        dispatch({type: "LOGOUT"})

    }
    return{logout}
}